/**
 * @generated SignedSource<<6baba8372013ad00170f965cb525042f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAppId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "customerAppId",
    "variableName": "customerAppId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAccountId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provisioningAccountId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAppFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAppT",
        "kind": "LinkedField",
        "name": "customerAppTByCustomerAppId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerAppFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CustomerAppT",
        "kind": "LinkedField",
        "name": "customerAppTByCustomerAppId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9684234c896b8b28d08a5285304d75d0",
    "id": null,
    "metadata": {},
    "name": "CustomerAppFetchQuery",
    "operationKind": "query",
    "text": "query CustomerAppFetchQuery(\n  $customerAppId: UUID!\n) {\n  customerAppTByCustomerAppId(customerAppId: $customerAppId) {\n    customerAppId\n    customerAccountId\n    provisioningAccountId\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "24ab8e8f6ef6aa0df0f8b3c9093a6432";

module.exports = node;
